import React, { Component, PropTypes } from 'react'
import styles from './ProgramConfiguration.css'

class ProgramConfiguration extends Component {

  render () {
    return (
      <div className='top20'>
        <div className='bottom40'>
          <div className='row bottom10 top10'>
            <div className='col-md-12'>Loyalty program time period</div>
          </div>
          <div className='checkbox time-period'>
            <label className='blur50'>
              <input type='checkbox' disabled /> Set time period (Coming Soon)
            </label>
          </div>
          <div className={`${styles.blur70}`}>
            For now, this Loyalty Program will run forever. You can choose to deactivate it later.
          </div>
        </div>
        <div className='bottom30'>
          <div className='row bottom10 top10'>
            <div className='col-md-12'>Security</div>
          </div>
          <div className='checkbox security-configuration'>
            <label>
              <input
                type='checkbox'
                checked={this.props.sentValidationCode}
                onChange={this.props.toggleSentValidationCode}
              />
              Send customer validation code
            </label>
          </div>
          <div className={`${styles.blur70}`}>
            If enabled, a validation code will be sent to customers via SMS for every reward redemptions.
          </div>
        </div>
      </div>
    )
  }
}

ProgramConfiguration.propTypes = {
  sentValidationCode: PropTypes.bool.isRequired,
  toggleSentValidationCode: PropTypes.func.isRequired
}

export default ProgramConfiguration



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/ProgramConfiguration/ProgramConfiguration.js